module.exports = __webpack_public_path__ + "static/media/undraw_Public_discussion_re_w9up.22e6540d.svg";